<!-- Admin only page -->
<template>
  <v-container>
    <div class="tiles-container">
      <user-count></user-count>
      <user-count :active-past-month="true"></user-count>

      <dashboard-link title="View Feedback" link-path="/feedback-review" class="d-block"></dashboard-link>

      <dashboard-link title="Send Email" link-path="/bulk-email" class="d-block"></dashboard-link>

      <review-count></review-count>
      <review-count title="Review Count (Past Month)" :minDate="thirtyDaysAgo" :imports="false"></review-count>
    </div>

    <cumulative-user-growth class="mt-3"></cumulative-user-growth>
  </v-container>
</template>

<script>
import userCount from "../../components/dashboard/user-count.vue";
import reviewCount from "../../components/dashboard/review-count.vue";
import cumulativeUserGrowth from "../../components/dashboard/cumulative-user-growth.vue";
import dashboardLink from "../../components/dashboard/dashboard-link.vue";

export default {
  name: "dashboard-page",

  components: { userCount, reviewCount, cumulativeUserGrowth, dashboardLink },

  computed: {
    thirtyDaysAgo() {
      let date = new Date();
      date.setDate(date.getDate() - 30);
      return date;
    },
  },
};
</script>

<style scoped>
.tiles-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
</style>
